import { useParams } from 'react-router';
import { MarketCodeSchema } from '@schuettflix/utils';
import { MarketContextProvider } from '@/shared/context/MarketContext.tsx';
import { HttpClientContextProvider } from '@/shared/context/HttpClientContext.tsx';
import { SalesforceDealImporterPage } from '@/modules/salesforceDealImporter/SalesforceDealImporterPage.tsx';
import { ConstructionProjectLoader } from '@/routes/loaders/ConstructionProjectLoader.tsx';
import { GetConstructionProjectResponse } from '@/clients/constructionProject/types/constructionProject.ts';
import { useOrganizationSuspenseQuery } from '@/clients/organization/useOrganization.ts';

type InnerSalesforceDealImporterRouteProps = {
    constructionProject?: GetConstructionProjectResponse;
};

function InnerSalesforceDealImporterRoute({ constructionProject }: InnerSalesforceDealImporterRouteProps) {
    const { opportunityId } = useParams<{ opportunityId: string }>();
    const { data: customerOrganization } = useOrganizationSuspenseQuery(constructionProject?.organizationId);

    if (!constructionProject || !opportunityId || !customerOrganization) {
        return;
    }

    const marketCode = MarketCodeSchema.parse(customerOrganization.market.code);

    return (
        <MarketContextProvider marketCode={marketCode}>
            <HttpClientContextProvider marketCode={marketCode}>
                <SalesforceDealImporterPage opportunityId={opportunityId} constructionProject={constructionProject} />
            </HttpClientContextProvider>
        </MarketContextProvider>
    );
}

export const SalesforceDealImporterRoute = ConstructionProjectLoader(InnerSalesforceDealImporterRoute);
